import DearisInsideImg from "@/assets/dearis-inside-instructure.png";
import type { StepsDataModal } from "@/components/step";

export const lanLineStepsData: StepsDataModal = {
  steps: [
    [
      {
        type: "text",
        content: "制御装置のディップスイッチの設定を行います。",
      },
      {
        type: "image",
        content: DearisInsideImg,
      },
      {
        type: "text",
        content:
          `設定ＳＷ２ー５、または２－７
          ･･･制御装置のＩＰアドレス設定
          *有線LANをご利用の場合はSW2-5を*
          *ON（DHCP有効）に変更ください。*

          ※通信アダプターをご利用の場合は前の画面に戻り通信アダプターを選択してください。

          ※制御装置の品番により、操作するスイッチが異なります。
           制御装置の品番が「ＶＭＸ－」から始まる場合は設定ＳＷ２－５を、
           制御装置の品番が「ＣＮ－Ｕ」から始まる場合は設定ＳＷ２－７を操作してください。
          `,
        indicator: 1,
      },
    ],
    [
      {
        type: "text",
        content:
          `設定ＳＷ２－６
          ･･･Pabbit設定
          ＯＮ(Pabbitサービス)に変更ください。
          ※全ての集合玄関機にPabbitの表示がされます。
          　Pabbitを非表示にさせたい集合玄関機がある場合は該当する集合玄関機の施工設定にて設定してください。`,
        indicator: 2,
      },
    ],
  ],
};

export const vmwComadStepsData: StepsDataModal = {
  steps: [
    [
      {
        type: "text",
        content: "制御装置のディップスイッチの設定を行います。",
      },
      {
        type: "image",
        content: DearisInsideImg,
      },
      {
        type: "text",
        content:
          `設定ＳＷ２ー５、または２－７
          ･･･制御装置のＩＰアドレス設定
          *無線（通信アダプター）を使用する場合は*
          *SW2-5をOFFにしてください。*
          \n
          ※ネットワーク業者よりＩＰアドレスの指定がされている場合もOFFのままになります。
          \n
          ※有線LANをご利用の場合は、前の画面に戻り共用部インターネット回線を選択してください。
          \n
          ※制御装置の品番により、操作するスイッチが異なります。
           制御装置の品番が「ＶＭＸ－」から始まる場合は設定ＳＷ２－５を、
           制御装置の品番が「ＣＮ－Ｕ」から始まる場合は設定ＳＷ２－７を操作してください。
          `,
        indicator: 1,
      },
    ],
    [
      {
        type: "text",
        content:
          `設定ＳＷ２－６
          ･･･Pabbit設定
          ＯＮ(Pabbitサービス)に変更ください。
          ※全ての集合玄関機にPabbitの表示がされます。
          　Pabbitを非表示にさせたい集合玄関機がある場合は該当する集合玄関機の施工設定にて設定してください。
          `,
        indicator: 2,
      },
    ],
  ],
};
